import React from 'react';
import Wrapper from './Wrapper';


const Component = (props) => {
  const {
    component,
    ...rest
  } = props;
  const Component = component;

  return (
    <Wrapper {...rest}>
      <Component {...props.props} />
    </Wrapper>
  )
}

export default Component;